import { render } from "./TacosCard.vue?vue&type=template&id=173f58f8"
import script from "./TacosCard.vue?vue&type=script&lang=js"
export * from "./TacosCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__